// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_l5-0";
export var buttonContainer = "_l5-3";
export var cancelButton = "_l5-4";
export var headerSection = "_l5-6";
export var headerTitle = "_l5-9";
export var messageSideLeft = "_l5-1";
export var messageSideRight = "_l5-2";
export var orderNumberContainer = "_l5-7";
export var orderNumberLabel = "_l5-8";
export var submitButton = "_l5-5";